"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoutingForm = void 0;
var _FormControlLabel2 = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _Checkbox2 = _interopRequireDefault(require("@mui/material/Checkbox"));
var _FormControl2 = _interopRequireDefault(require("@mui/material/FormControl"));
var _Select2 = _interopRequireDefault(require("@mui/material/Select"));
var _MenuItem2 = _interopRequireDefault(require("@mui/material/MenuItem"));
var _Chip2 = _interopRequireDefault(require("@mui/material/Chip"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Add2 = _interopRequireDefault(require("@mui/icons-material/Add"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _styles = require("@mui/material/styles");
var _maplibreGl = require("maplibre-gl");
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _reactI18next = require("react-i18next");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _services = require("../../services");
var _utils = require("../../utils");
var _icons = require("../icons");
var _wayPointRow = require("./way-point-row");
var _wayPointsList = require("./way-points-list");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const bikeTypes = [{
  Icon: _icons.OwnBikeIcon,
  key: 'own',
  labelKey: 'commons.routing.form.bike_types.own'
}, {
  Icon: _icons.SharedBikeIcon,
  key: 'shared',
  labelKey: 'commons.routing.form.bike_types.shared'
}, {
  Icon: _icons.CargoBikeIcon,
  key: 'cargo',
  labelKey: 'commons.routing.form.bike_types.cargo',
  status: _models.cyclingProfiles.cargo?.status
}, {
  Icon: _icons.HybridBikeIcon,
  key: 'hybridBike',
  labelKey: 'commons.routing.form.bike_types.hybrid_bike',
  status: _models.cyclingProfiles.hybridBike?.status
}];
function _RoutingForm({
  theme,
  size,
  readOnly,
  map,
  mapPadding,
  zoom,
  mapInteractionsDisabled,
  disableMapAnimation,
  defaultOptions,
  disableRideItinerary,
  disableBikeType,
  disableEBike,
  disableNewStepAddition,
  newStepPosition,
  disableTooltip,
  retrieveElevations,
  enableSingleResult,
  enableCyclingQualities,
  disableOtherResultsForHybridBike,
  geolocation,
  userPlaces,
  search,
  wayPoints,
  carRoute,
  computedRoutes,
  selectedComputedRouteIndex,
  setWayPoints,
  selectComputedRouteIndex,
  setComputedRoutes,
  onContextMenuOpen,
  onResponse,
  onUpdate
}, ref) {
  const {
    trackEvent
  } = (0, _hooks.useAmplitudeTracker)();
  const [facilityDistributionEnabled, enableFacilityDistribution] = (0, _react.useState)(false);
  const [bikeType, setBikeType] = (0, _react.useState)(search.bikeType);
  const [eBikeEnabled, enableEBike] = (0, _react.useState)(search.eBikeEnabled);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const snackbar = (0, _notistack.useSnackbar)();
  const {
    init: initMap,
    updateWayPoints: updateWayPointsOnMap,
    showPreview: showPreviewOnMap,
    showCarRoute: showCarRouteOnMap,
    showRoutes: showRoutesOnMap,
    clearRoutes: clearRoutesOnMap,
    destroy: destroyMap
  } = (0, _hooks.useRouting)(theme, map, search, {}, {
    disableNewStepAddition,
    hidePopup: disableTooltip,
    readOnly,
    onSearchUpdated: handleWayPointUpdatedOnMap,
    onRouteSelected: index => {
      const route = computedRoutes?.[index];
      if (route && route.cyclingProfile) search.profile = route.cyclingProfile;
      selectComputedRouteIndex?.(index);
    },
    onContextMenuOpen
  }, !mapInteractionsDisabled);
  const {
    cancellablePromise,
    cancelPromises
  } = (0, _hooks.useCancellablePromise)();
  (0, _react.useEffect)(() => {
    return () => {
      cancelPromises();
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (_services.UserService.currentUser && !computedRoutes && bikeType === 'own') {
      search.profile = _services.UserService.currentUser.parameters.profile;
    }
  }, [_services.UserService.currentUser]);
  (0, _react.useEffect)(() => {
    if (map) {
      initMap();
    }
    return () => {
      destroyMap();
    };
  }, [map]);
  (0, _react.useEffect)(() => {
    if (zoom) {
      if (facilityDistributionEnabled && zoom < _hooks.facilityDistributionMinZoom) enableFacilityDistribution(false);else if (!facilityDistributionEnabled && zoom >= _hooks.facilityDistributionMinZoom) enableFacilityDistribution(true);
    }
  }, [zoom]);
  (0, _react.useEffect)(() => {
    if (wayPoints.every(Boolean)) {
      const preview = (0, _utils.getRoutePreview)(wayPoints);
      const {
        north,
        east,
        south,
        west
      } = (0, _utils.toBounds)(preview.geometry);
      map?.fitBounds(new _maplibreGl.LngLatBounds({
        lat: south,
        lng: west
      }, {
        lat: north,
        lng: east
      }), {
        padding: mapPadding,
        animate: !disableMapAnimation
      });
    }
  }, [wayPoints]);
  (0, _react.useEffect)(() => {
    if (computedRoutes) {
      showRoutesOnMap(computedRoutes, selectedComputedRouteIndex, {
        enableFacilityDistribution: true
      });
      if (carRoute) showCarRouteOnMap(carRoute, computedRoutes.length, selectedComputedRouteIndex);
    }
  }, [map, computedRoutes, selectedComputedRouteIndex, facilityDistributionEnabled, carRoute]);
  (0, _react.useEffect)(() => {
    const computedRoute = computedRoutes?.[selectedComputedRouteIndex];
    if (map && computedRoutes && computedRoute) {
      const {
        bounds
      } = computedRoute;
      if (bounds) {
        const {
          north,
          east,
          south,
          west
        } = bounds;
        map.fitBounds(new _maplibreGl.LngLatBounds({
          lat: south,
          lng: west
        }, {
          lat: north,
          lng: east
        }), {
          padding: mapPadding,
          animate: !disableMapAnimation
        });
      }
    }
  }, [map, computedRoutes, selectedComputedRouteIndex]);
  (0, _react.useImperativeHandle)(ref, () => ({
    updateBikeType,
    updateWayPoints: showPreview => {
      updateWayPoints(showPreview);
      updateWayPointsOnMap(search.wayPoints);
    },
    updateWayPointsOnMap: () => updateWayPointsOnMap(search.wayPoints)
  }));
  async function compute(showPreview = true) {
    cancelPromises();
    selectComputedRouteIndex?.(0);
    if (!search.computable) {
      clearRoutesOnMap();
      setComputedRoutes(null);
      onResponse?.(null);
      return;
    }
    if (showPreview) {
      const preview = (0, _utils.getRoutePreview)(search.wayPoints);
      showPreviewOnMap(preview);
    }
    setComputedRoutes(undefined);
    onResponse?.(undefined);
    try {
      trackEvent('Route Computed');
      const {
        response,
        computedRoutes
      } = await cancellablePromise(_services.ComputedRouteService.compute(search, {
        showRideItinerary: disableRideItinerary ? false : true,
        bikeParkings: false,
        elevations: retrieveElevations || false,
        facilities: true,
        energy: true,
        geometry: true,
        instructions: true,
        showPushingBikeInstructions: true,
        singleResult: Boolean(enableSingleResult) || disableOtherResultsForHybridBike && search.bikeType === 'hybridBike',
        roadCyclingQualities: enableCyclingQualities || false
      }));
      if (computedRoutes.length === 0) throw new Error('no route');
      const orders = {
        cargo: 0,
        hybridBike: 0,
        eBike: 0,
        daily: 1,
        safe: 2,
        direct: 3,
        touristic: 4
      };
      computedRoutes.sort((a, b) => {
        if (a.cyclingProfile && b.cyclingProfile) {
          return orders[a.cyclingProfile] - orders[b.cyclingProfile];
        }
        return 0;
      });
      if (search.bikeType === 'own') {
        const index = computedRoutes.findIndex(({
          cyclingProfile
        }) => cyclingProfile === search.profile) || 0;
        selectComputedRouteIndex?.(index);
      }
      setComputedRoutes(computedRoutes);
      onResponse?.(response);
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        setComputedRoutes([]);
        onResponse?.([]);
        snackbar?.enqueueSnackbar(t('commons.routing.form.server_error'), {});
      }
    }
  }
  function updateBikeType(_bikeType, defaultProfile = 'daily') {
    setBikeType(_bikeType);
    search.bikeType = _bikeType;
    search.profile = _bikeType === 'hybridBike' ? 'hybridBike' : _bikeType === 'cargo' ? 'cargo' : defaultProfile;
    search.transportModes = _bikeType === 'shared' ? ['bike', 'pedestrian'] : ['bike'];
    onUpdate?.();
    compute();
  }
  function handleBikeTypeChange({
    target: {
      value
    }
  }) {
    updateBikeType(value);
  }
  function handleEBikeToggle(_, checked) {
    enableEBike(checked);
    search.eBikeEnabled = checked;
    onUpdate?.();
    compute();
  }
  async function updateWayPoints(showPreview) {
    setWayPoints([...search.wayPoints]);
    onUpdate?.();
    compute(showPreview);
    if (!search.wayPoints.find(wayPoint => wayPoint && !wayPoint.addressDetail)) return;
    try {
      const newWayPoints = await cancellablePromise(Promise.all(search.wayPoints.map(wayPoint => wayPoint && !wayPoint.addressDetail ? _services.GeocoderService.reverseGeocode(undefined, wayPoint.point) : wayPoint?.clone())));
      search.wayPoints = newWayPoints;
      setWayPoints(newWayPoints);
    } catch {
      //
    }
  }
  function handleWayPointUpdatedOnMap() {
    updateWayPoints(false);
  }
  function handleWayPointBlur(index) {
    if (index > 1 && !search.wayPoints[index]) {
      const newWayPoints = [...search.wayPoints];
      newWayPoints.splice(index, 1);
      search.wayPoints = newWayPoints;
      setWayPoints(newWayPoints);
    } else {
      setWayPoints([...search.wayPoints]);
    }
  }
  function handleWayPointChange(index, place) {
    const newWayPoints = [...search.wayPoints];
    if (!place && search.wayPoints.length > 2) newWayPoints.splice(index, 1);else newWayPoints[index] = place;
    search.wayPoints = newWayPoints;
    setWayPoints(newWayPoints);
    updateWayPointsOnMap(newWayPoints);
    if (!search.computable && place) {
      const {
        point: {
          coordinates: [lng, lat]
        }
      } = place;
      map?.flyTo({
        center: {
          lat,
          lng
        },
        zoom: Math.max(15, map.getZoom())
      });
    }
    onUpdate?.();
    compute();
  }
  function handleReverse() {
    const newWayPoints = [...search.wayPoints];
    newWayPoints.reverse();
    search.wayPoints = newWayPoints;
    setWayPoints(newWayPoints);
    updateWayPointsOnMap(newWayPoints);
    onUpdate?.();
    compute();
  }
  function handleStepAdd() {
    const newWayPoints = [...search.wayPoints];
    const index = newStepPosition === 'before_last' ? search.wayPoints.length - 1 : search.wayPoints.length;
    newWayPoints.splice(index, 0, undefined);
    search.wayPoints = newWayPoints;
    setWayPoints(newWayPoints);
    setTimeout(() => document.getElementById(`way-point-${index}-autocomplete`)?.focus(), 200);
  }
  function handleWayPointItemDragEnd({
    source,
    destination
  }) {
    if (!destination || source.index === destination.index) return;
    const newWayPoints = [...search.wayPoints];
    const [movedWayPoint] = newWayPoints.splice(source.index, 1);
    newWayPoints.splice(destination.index, 0, movedWayPoint);
    search.wayPoints = newWayPoints;
    setWayPoints(newWayPoints);
    updateWayPointsOnMap(newWayPoints);
    onUpdate?.();
    compute();
  }
  const computable = Boolean(wayPoints[0]) && Boolean(wayPoints[1]);
  const newStepAdditionEnabled = !disableNewStepAddition && computable && Boolean(wayPoints[wayPoints.length - 1]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, null, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: handleWayPointItemDragEnd
  }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable"
  }, droppableProvided => /*#__PURE__*/_react.default.createElement(_Box2.default, _extends({
    flexGrow: 1
  }, droppableProvided.droppableProps, {
    marginLeft: "-20px",
    ref: droppableProvided.innerRef
  }), /*#__PURE__*/_react.default.createElement(_wayPointsList.WayPointsList, {
    draggable: true
  }, wayPoints.map((_, index) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: index
  }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Draggable, {
    draggableId: `${index}`,
    index: index,
    isDragDisabled: readOnly
  }, draggableProvided => /*#__PURE__*/_react.default.createElement("div", _extends({
    ref: draggableProvided.innerRef
  }, draggableProvided.draggableProps, draggableProvided.dragHandleProps), /*#__PURE__*/_react.default.createElement(_wayPointRow.WayPointRow, {
    draggable: true,
    defaultOptions: defaultOptions,
    geolocation: geolocation,
    index: index,
    map: map,
    mapHasContextMenu: Boolean(onContextMenuOpen),
    onBlur: handleWayPointBlur,
    onChange: handleWayPointChange,
    readonly: readOnly,
    size: size,
    userPlaces: userPlaces,
    wayPoints: wayPoints
  }))))), droppableProvided.placeholder)))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignSelf: "stretch",
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    gap: 2,
    justifyContent: "space-between",
    paddingY: 1,
    width: 30
  }, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: t('commons.routing.actions.swap') || ''
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    disabled: readOnly,
    onClick: handleReverse,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_icons.SwapIcon, {
    fontSize: "small"
  }))), newStepAdditionEnabled && /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: t('commons.routing.actions.add_step', {
      context: newStepPosition === 'before_last' ? 'before_last' : ''
    }) || ''
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    disabled: readOnly,
    onClick: handleStepAdd,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Add2.default, {
    fontSize: "small"
  })))))), (!disableBikeType || !disableEBike) && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "stretch",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    marginTop: 3
  }, !disableBikeType && /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 600
  }, t('commons.routing.form.bike_type')), /*#__PURE__*/_react.default.createElement(_FormControl2.default, {
    fullWidth: true,
    color: "secondary",
    size: "small",
    sx: {
      minWidth: 180
    }
  }, /*#__PURE__*/_react.default.createElement(_Select2.default, {
    color: "primary",
    inputProps: {
      sx: {
        alignItems: 'center',
        display: 'flex',
        gap: 1
      }
    },
    onChange: handleBikeTypeChange,
    sx: {
      borderRadius: '10px'
    },
    value: bikeType
  }, bikeTypes.map(({
    key,
    Icon,
    labelKey,
    status
  }) => /*#__PURE__*/_react.default.createElement(_MenuItem2.default, {
    disabled: status === 'comingSoon',
    key: key,
    sx: theme => ({
      '&&': {
        alignItems: 'center',
        display: 'flex',
        color: status === 'comingSoon' ? theme.palette.text.secondary : 'inherit',
        gap: 1,
        opacity: 1,
        '&.Mui-selected': {
          backgroundColor: (0, _styles.lighten)(theme.palette.primary.main, 0.9)
        },
        '&:hover': {
          backgroundColor: (0, _styles.lighten)(theme.palette.primary.main, 0.8)
        }
      }
    }),
    value: key
  }, /*#__PURE__*/_react.default.createElement(Icon, null), /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    i18nKey: labelKey
  }), status && /*#__PURE__*/_react.default.createElement(_Chip2.default, {
    color: "secondary",
    label: /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
      i18nKey: status === 'comingSoon' ? 'commons.routing.form.coming_soon' : 'commons.routing.form.beta'
    }),
    size: "small",
    sx: {
      cursor: 'inherit'
    }
  })))))), !disableEBike && /*#__PURE__*/_react.default.createElement(_FormControlLabel2.default, {
    control: /*#__PURE__*/_react.default.createElement(_Checkbox2.default, {
      checked: eBikeEnabled,
      color: "primary",
      onChange: handleEBikeToggle,
      sx: {
        marginRight: 1,
        padding: '4px'
      }
    }),
    label: t('commons.routing.form.e_bike'),
    sx: {
      margin: 0
    }
  })));
}
const RoutingForm = exports.RoutingForm = /*#__PURE__*/(0, _react.forwardRef)(_RoutingForm);